import { useTier } from '../lib/useTier.js';

// TierBadge — small inline pill showing the current vendor's plan.
// Use anywhere we want to surface "you're on the X plan" in the UI.
//
// Variants:
//   default → "Pilot plan" with subtle accent (current/most users)
//   compact → just "Pilot" (used in tight nav contexts if needed later)
//
// Built as part of PRICING A scaffolding (2026-05-15). Hard enforcement comes in
// PRICING B + C — this badge currently just displays, doesn't gate anything.

export default function TierBadge({ variant = 'default' }) {
  const { tier, loading } = useTier();

  if (loading) return null;

  const compact = variant === 'compact';

  return (
    <span
      className={`tier-badge tier-badge-${tier.id} ${compact ? 'tier-badge-compact' : ''}`}
      title={tier.tagline}
    >
      {compact ? tier.name : `${tier.name} plan`}
    </span>
  );
}
